"use client";

import React from "react";

const DentalProfessionals: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Dental Professionals: A Trusted Source of Fluoride Treatment
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        When it comes to fluoride treatment, dental professionals are your best source of information and care. They have the training, experience, and knowledge to provide you with personalized recommendations based on your unique oral health needs.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        At Smile4Me, we&#39;re committed to helping our patients maintain optimal oral health through preventive dentistry. Our team of skilled dental professionals is dedicated to providing top-notch fluoride treatments tailored to each patient&#39;s individual requirements. We use the latest technology and highest quality materials to ensure that you receive the best possible care.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        In addition to fluoride treatments, we offer a wide range of services designed to keep your smile healthy and bright. From dental cleanings and sealants to cosmetic dentistry and teeth whitening, we&#39;re here to help you achieve the beautiful, confident smile you deserve.
      </p>
    </div>
  );
};

export default DentalProfessionals;